import React, { useEffect } from 'react';
import get from 'lodash/get';
import { useOidcJwtSub } from 'stores/rq/oidc-jwt-subs';
import type { CredentialsInputProps } from 'components/organizations/credentials/credential-modal';
import OidcClaimField from 'components/organizations/credentials/oidc-claim-field';

interface JwtOidcSubProps {
  form: CredentialsInputProps['form'];
}

const JwtOidcSub: React.FunctionComponent<JwtOidcSubProps> = ({ form }) => {
  const { data: sub, isPending, error } = useOidcJwtSub(true, true);

  useEffect(() => {
    form.register('value.jwtOidcSub' as never);
  }, [form]);

  useEffect(() => {
    if (sub && (form.getValues() as any).value?.jwtOidcSub !== sub) {
      form.setValue('value.jwtOidcSub' as never, sub);
      form.clearErrors('value.jwtOidcSub' as never);
    }
    if (error && !(form.errors as any).value?.jwtOidcSub) {
      form.setError('value.jwtOidcSub' as never, { message: 'settings.credentials.error.missingJwtOidcSub' });
    }
  }, [form, sub, error]);

  return (
    <OidcClaimField
      labelId="settings.credentials.jwt-oidc-sub"
      value={sub}
      loading={isPending}
      error={get(form.errors, 'value.jwtOidcSub.message')}
      dataE2e="jwt-oidc-sub"
    />
  );
};

export default JwtOidcSub;
